import React from "react";
import { useNavigate } from "react-router-dom";
import { PageShell, SoftCard, GhostButton } from "./ui";
import { useAstriaCopy } from "./copy";
import PlanBanner from "./PlanBanner";
import GlobalPassCard from "./GlobalPassCard";
import ZodiacCard from "./ZodiacCard";

const TodayPage: React.FC = () => {
  const navigate = useNavigate();
  const c = useAstriaCopy();

  return (
    <PageShell title={c("navToday")}>
      <GlobalPassCard />
      <PlanBanner />
      <ZodiacCard />
      <SoftCard>
        <div className="flex items-center justify-between">
          <div className="text-xs uppercase tracking-widest text-astria-muted">{c("navJourney")}</div>
          <GhostButton onClick={() => navigate("/journey-story")}>{c("open")}</GhostButton>
        </div>
        <ol className="mt-3 space-y-3 border-l border-white/10 pl-4">
          <li className="text-astria-text">{c("miniReflection")}</li>
          <li className="text-astria-muted">{c("miniCheckin")}</li>
        </ol>
      </SoftCard>
    </PageShell>
  );
};

export default TodayPage;
